import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { RegisterComponent } from './components/register/register.component';
import { ActiveAccountComponent } from './components/active-account/active-account.component';
import { AfterAccountComponent } from './components/after-account/after-account.component';
import { ForgetPassWordComponent } from './components/forget-pass-word/forget-pass-word.component';
import { EditPassWordComponent } from './components/edit-pass-word/edit-pass-word.component';
import { CheckedEmailComponent } from './components/checked-email/checked-email.component';
import { AfterUpdatepwdComponent } from './components/after-updatepwd/after-updatepwd.component';

const routes: Routes = [

  {
    path:'',
    component:LoginComponent
  },
  {
    path:'login',
    component:LoginComponent
  },
  {
    path:'register',
    component:RegisterComponent
  }
  ,
  {
    path:'active',
    component:ActiveAccountComponent
  },
  {
    path:'message-confirmation',
    component:AfterAccountComponent
    
  },{
    path:'forget-password',
    component:ForgetPassWordComponent
  },
  {
    path:"edit-password",
    component:EditPassWordComponent
  },
  {
    path:"check-email",
    component:CheckedEmailComponent
  },
  {
    path:"after-account",
    component:AfterAccountComponent
  }
  ,
  {
    path:"after-update",
    component:AfterUpdatepwdComponent
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule { }
